import React from 'react';
import Typography from '@material-ui/core/Typography';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Box } from '@material-ui/core';

import { pxToRem } from 'src/helpers/pxToRem';
import { WarningIcon } from 'src/assets/svgs/warning';

import { Member } from '../../../../../../models/Common';
import { colors } from '../../../../../../themes/colors';
import { MemberNameTestID } from './constants';

const styles = (theme) =>
  createStyles({
    memberName: {
      alignItems: 'center',
      color: colors.black4,
      display: 'flex',
      flexDirection: 'row',
      fontSize: 14,
      fontWeight: 900,
      minWidth: 150,
      transition: theme.transitions.create(['color', 'text-decoration']),
    },
  });

interface MemberNameProps {
  member: Member;
}

type Props = WithStyles<typeof styles> & MemberNameProps;

const MemberName: React.FC<Props> = ({ classes, member }) => {
  const { showMemberPhq9SelfharmScore } = useFlags();
  return (
    <div className={classes.memberName} data-testid={MemberNameTestID}>
      {showMemberPhq9SelfharmScore &&
        !!member.phq9SelfharmScores &&
        member.phq9SelfharmScores.length > 0 && (
          <Box display="inline-block" marginRight={pxToRem(5)}>
            <WarningIcon />
          </Box>
        )}
      <Typography>{`${member.firstName} ${member.lastName}`}</Typography>
    </div>
  );
};

export default withStyles(styles)(MemberName);
